import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../store/configureStore';
import './club-finder-search-bar.scss';
import SearchSuggestLocation from '../../molecules/search-suggest-locations/search-suggest-location';
import searchIconDark from '../../assets/icons/search-icon-dark.svg';
import searchIconLight from '../../assets/icons/search-icon-light.svg';
import SearchFormatInput from '../../atoms/search-bar-filter-components/format/search-format-input/search-format-input';
import icon from '../../assets/icons/search-icon-dark.svg';
import close from '../../assets/icons/cross.svg';
import SearchGenderInput from '../../atoms/search-bar-filter-components/gender/search-gender-input/search-gender-input';
import {Config} from '../../../constants/Config';
import {clubFinderSearchBarSliceActions} from "../../../store/slices/clubFinderSearchBarSlice";
import {
  clubFinderMapResultSliceActions
} from "../../../store/slices/clubFinderResultMapSlice";

const baseClass = 'clubFinder-search-bar';
const MobileViewWidth = Config.breakpoints.large.width;
const ClubFinderSearchBar = (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const isSelectionSearchable = useSelector((state: RootState) => state.clubFinderSearchBarStore.isSearchable);
  const searchOptionsLoaded = useSelector((state: RootState) => state.clubFinderSearchBarStore.searchOptionsLoaded);
  const isMobileSearchVisible = useSelector((state: RootState) => state.clubFinderSearchBarStore.isMobileSearchVisible);
  const parentWidth = useSelector((state: RootState) => state.widgetConfigurationSettings.widgetParentWidth);
  const [showMobileSearchBarClass, setShowMobileSearchBarClass] = useState('clubFinder-search-bar--hide');
  const selectedLocation = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedLocation);
  const savedFormatFilterName = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName);
  const selectedGenderFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedGenderFilter);
  const searchButtonPressed = useSelector((state: RootState) => state.clubFinderSearchBarStore.searchButtonPressed);
  const [filterTopMargin, setFilterTopMargin] = useState('0');
  const windowHeight = window.innerHeight + 'px';

  const search = () => {
    try {
      dispatch(clubFinderSearchBarSliceActions.searchButtonPressed(!searchButtonPressed));
      dispatch(clubFinderSearchBarSliceActions.toggleMobileSearch(false));
    } catch (e) {
      console.log("Error finding club:", e);
    }
  }

  const hideMobileFilter = () => {
    dispatch(clubFinderMapResultSliceActions.setIsMapExpanded(false));
    dispatch(clubFinderSearchBarSliceActions.toggleMobileSearch(false));
  }

  const handleResetFilter = (clearOrCancel: string) => {
    if(clearOrCancel === 'Clear') {
      dispatch(clubFinderSearchBarSliceActions.setSavedGenderFilter(Config.defaultGenderOption));
      dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({selectedFormatObject: null, selectedFormatTitles: null}));
      dispatch(clubFinderSearchBarSliceActions.setSelectedLocation(null));
      dispatch(clubFinderSearchBarSliceActions.activeSearchFilterMobile({location: false, format: false, gender: false}));
      dispatch(clubFinderMapResultSliceActions.setClubFinderListResult(null));
    } else {
      hideMobileFilter();
    }
  }

  useEffect(() => {
    if (parentWidth <= MobileViewWidth) {
      if (isMobileSearchVisible) {
        setShowMobileSearchBarClass('clubFinder-search-bar--show');
        //TODO: Enable if  required
        // document.body.style.overflow = 'hidden';
      } else {
        setShowMobileSearchBarClass('clubFinder-search-bar--hide');
        //TODO: Enable if  required
        // document.body.style.overflow = 'unset';
      }
      if (props.clubFinderOffset) {
        if (props.clubFinderOffset.includes('px')) {
          setFilterTopMargin(props.clubFinderOffset);
        } else {
          setFilterTopMargin(`${props.clubFinderOffset}px`);
        }
      }
    } else {
      setShowMobileSearchBarClass('');
      setFilterTopMargin('');
    }
  }, [parentWidth, isMobileSearchVisible, props.clubFinderOffset]);

  let clearOrCancel = 'Cancel';
  if(selectedLocation || savedFormatFilterName || (selectedGenderFilter.type !== Config.defaultGenderOption.type)) {
    clearOrCancel = 'Clear'
  }

  return (
    <div className={`${baseClass} ${showMobileSearchBarClass} ${searchOptionsLoaded ? baseClass+'--white' : ''}`} style={{'--top-offset': filterTopMargin, '--window-height': windowHeight} as React.CSSProperties}>
      <div className={`${baseClass}--container`}>
        <div className={`${baseClass}--container-wrapper`}>
          <div className={`${baseClass}--hide-search-button`} onClick={hideMobileFilter}>
            <img src={close} alt={'Close'}/>
          </div>
          <div className={`${baseClass}--search-filter ${baseClass}--search-filter-location`}>
            <SearchSuggestLocation/>
          </div>

          <span className={`${baseClass}--separator`}></span>
          <div className={`${baseClass}--search-filter ${baseClass}--search-filter-format`}>
            <SearchFormatInput label={"Format"} inputBoxIcon={icon} placeholder={'How do you want to play?'}
                               formatDetailsObject={props.formatDetails}/>
          </div>
          <span className={`${baseClass}--separator`}></span>
          <div className={`${baseClass}--search-filter ${baseClass}--search-filter-gender`}>
            <SearchGenderInput label={"For?"} placeholder={'Anyone'} genderOptions={props.genders}/>
          </div>
          <div
            className={`${baseClass}--search-button ${baseClass}--search-button-${isSelectionSearchable ? 'searchable' : 'not-searchable'}`}>
            <button onClick={isSelectionSearchable ? search : () => void (0)}>
              <img src={isSelectionSearchable ? searchIconLight : searchIconDark} alt={'search icon'}/>
            </button>
          </div>
        </div>
        <div className={`${baseClass}--footer`}>
          <div className={`${baseClass}--footer-clear-button`} onClick={() => handleResetFilter(clearOrCancel)}>
            {clearOrCancel}
          </div>
          <div
            className={`${baseClass}--footer-search-button ${isSelectionSearchable ? 'searchable' : 'not-searchable'}`}
            onClick={isSelectionSearchable ? search : () => void (0)}>Search
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClubFinderSearchBar;
